import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AOS from "aos";
import 'aos/dist/aos.css';
import './InstalarApp.css'
import { Accordion, Navbar, Nav, Container, NavDropdown, Row, Col, Button, Card, Form, Alert} from "react-bootstrap";
import { BsMap, BsEnvelope, BsInstagram } from "react-icons/bs";
import Swiper from "swiper";
import "swiper/css";
import BtnInstalarApp from '../components/Button/InstalarApp';
import { useProvider } from '../context/MenuProvider'; // Importando o hook do contexto

const InstalarApp = () => {
  
  return (
    <div className="appland">
      <Header />
      <HeroSection />
      <main id="main">
        <Features />
        <DetailsSection />
        <GallerySection />
        <TestimonialsSection />
        <PricingSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTopButton />
    </div>
  );
};


const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const {
    site
  } =useProvider();
  // Função para fechar o menu
  const handleClose = () => setExpanded(false);

  return (
    <header id="header" className="fixed-top header-transparent">
      <Navbar expanded={expanded} expand="lg" className="navbar">
        <Container>
          {/* Logo */}
          <Navbar.Brand href="#hero">
            <h1>{site?.name}</h1>
          </Navbar.Brand>

          {/* Botão de toggle para dispositivos móveis */}
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          />

          {/* Navegação */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto" onSelect={handleClose}>
              <Nav.Item>
                <Nav.Link href="#hero" onClick={handleClose}>Início</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#features" onClick={handleClose}>Recursos do aplicativo</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#gallery" onClick={handleClose}>Galeria</Nav.Link>
              </Nav.Item>
              <Nav.Item className="d-none">
                <Nav.Link href="#pricing" onClick={handleClose}>Pricing</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href="#faq" onClick={handleClose}>F.A.Q</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="getstarted" onClick={()=> {window.open(`https://${site?.domain}/login`); handleClose()}}>Login</Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};


const HeroSection = () => {
  const { 
    buscarDadosPorId,
    crud,
    site,
    salvarDados,
  } = useProvider();
  const { get } = crud || {};
  const { indicacao } = useParams();
  const [patrocinador,setPatrocinador] = useState(null);
  
  useEffect(()=>{
    const buscarPatrocinador = async() => {
      const response = await buscarDadosPorId('local_registros','indicacao');
      if(response){
        setPatrocinador(response);
      }
    }
    const buscarEmpresa = async () => {
      //alert(indicacao)
      try{
        const response = await get(
          `/gvendas/empresas/?url=${indicacao}&limit=1`,
          'indicacao',
          false
        );
        //alert(JSON.stringify(response))
        if (response && response.length && response[0].results?.length){
          await salvarDados('local_registros',{
            ...response[0].results[0],
            id:'indicacao'
          });
          setPatrocinador(response[0].results[0]);
        }
      }catch(err){
        //alert(JSON.stringify(err.response))
      }
    }
    buscarPatrocinador();
    if (indicacao) buscarEmpresa();
  },[indicacao])
  
  const abrirAppAndroid =(packageName)=>{
      const fallbackUrl = `https://play.google.com/store/apps/details?id=${packageName}`;
      window.location.href = `intent://#Intent;package=${packageName};end;S.browser_fallback_url=${encodeURIComponent(fallbackUrl)}`;
  }
  return (
    <section id="hero" className="d-flex align-items-center">
      <Container>
        <Row>
          <Col
            lg={6}
            className="d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-2 order-lg-1"
            data-aos="fade-up"
          >
            <div>
              <h1>Sistema de Gestão de Vendas</h1>
              <h2>Gerencie suas vendas de forma prática e eficiente com nossa aplicação de Gerenciamento de Vendas!</h2>
              <BtnInstalarApp open={true} />
              {site?.pacote_android && (<>
                <h2>
                  Também disponível em
                </h2>
                <Button
                  onClick={() => abrirAppAndroid(site?.pacote_android)}
                  className="download-btn"
                  variant="primary"
                  size="lg"
                >
                  <i className="bx bxl-play-store"></i> Play Store
                </Button>
              </>)}
            </div>
            {patrocinador && (
              <h2 className="pt-3">
                <div>Por <span className="fs-5">{patrocinador?.nome_da_loja}</span></div>
                <div>{patrocinador?.telefone_whatsapp}</div>
                <div className="text-muted small">{patrocinador?.descricao}</div>
              </h2>
            )}
          </Col>
          <Col
            lg={6}
            className="d-lg-flex flex-lg-column align-items-stretch order-1 order-lg-2 hero-img"
            data-aos="fade-up"
          >
            <img
              src="/install-app/hero-img.png"
              className="img-fluid"
              alt="Imagem de herói"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const Footer = () => {
  const { 
    site,
  } = useProvider();
  return (
    <footer id="footer">
      <div className="footer-newsletter d-none">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <h4>Join Our Newsletter</h4>
              <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
              <form action="" method="post">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe" />
              </form>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-top">
        <Container>
          <Row>
            <Col lg={3} md={6} className="footer-contact">
              <h3>{site?.name}</h3>
              <p>
                <strong>Email:</strong> franciscosilva.executivo@gmail.com<br />
              </p>
            </Col>

            <Col lg={3} md={6} className="footer-links">
              <h4>Sessões úteis</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a className="scrollto" href="#hero">
                    Home
                  </a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a className="scrollto" href="#features">
                    Recursos do App
                  </a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a className="scrollto" href="#gallery">
                    Galeria
                  </a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a className="scrollto" href="#faq">
                    F.A.Q
                  </a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a className="scrollto" href="#contact">
                    Contato
                  </a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a className="scrollto" onClick={()=>window.open(`https://${site?.domain}/login`)}>
                    Login
                  </a>
                </li>
              </ul>
            </Col>

            <Col lg={3} md={6} className="footer-links">
              <h4>Outros serviços</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a href="https://api.gvendas.app.br/">Api para desenvolvedores</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a href="https://evgrupohinode.page.link/Y3JKFMXQ235XB5fS9">E-comerce</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a href="https://vo.hinode.com.br/cadastro/64868853">Quero revender algo</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a href="https://vo.hinode.com.br/cadastro/64868853">Trabalhe comigo</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>{' '}
                  <a href="https://nubank.com.br/cobrar/jnff9/668d8b36-03b9-421e-8cd6-88429c0de30f">
                    Ajudar para melhorias do app
                  </a>
                </li>
              </ul>
            </Col>

            <Col lg={3} md={6} className="footer-links">
              <h4>Redes Sociais</h4>
              <p>Acompanhe nas redes sociais</p>
              <div className="social-links mt-3">
                <a href="https://x.com/fsilva_oficial?s=09" className="twitter">
                  <i className="bx bxl-twitter"></i>
                </a>
                <a href="https://www.facebook.com/franciscosilva.executivo?mibextid=ZbWKwL" className="facebook">
                  <i className="bx bxl-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/franciscosilva_executivo?igsh=MWJiYXc3eG03ZHpudw=="
                  className="instagram"
                >
                  <i className="bx bxl-instagram"></i>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="container py-4">
        <div className="copyright">
          &copy; Copyright <strong><span>{site?.name}</span></strong>. Todos direitos reservados
        </div>
        <div className="credits">
          Designed by <a href="https://www.instagram.com/franciscosilva_executivo?igsh=MWJiYXc3eG03ZHpudw==">Francisco Silva</a>
        </div>
      </div>
    </footer>
  );
};

const BackToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <a
      href="#"
      className={`back-to-top d-flex align-items-center justify-content-center ${showButton ? 'active' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        scrollToTop();
      }}
    >
      <i className="bi bi-arrow-up-short"></i>
    </a>
  );
};

const Features = () => {
  return (
    <section id="features" className="features">
      <Container>
        <div className="section-title">
          <h2>Recursos do aplicativo</h2>
          <p>
            Transforme a gestão das suas vendas com nosso app: controle seu estoque sem esforço, conheça melhor
            seus clientes com histórico de compras, facilite vendas parceladas com comprovantes enviados pelo
            WhatsApp e alcance suas metas com relatórios diários personalizados!
          </p>
        </div>

        <Row className="no-gutters">
          <Col xl={7} className="d-flex align-items-stretch order-2 order-lg-1">
            <div className="content d-flex flex-column justify-content-center">
              <Row>
                <Col md={6} data-aos="fade-up">
                  <Card className="icon-box">
                    <Card.Body>
                      <i className="bx bx-archive-in"></i>
                      <h4>Controle de Estoque</h4>
                      <p>
                        Atualização instantânea do estoque a cada venda realizada, garantindo sempre informações
                        precisas e atualizadas sobre seus produtos.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="100">
                  <Card className="icon-box">
                    <Card.Body>
                      <i className="bx bx-group"></i>
                      <h4>Gestão Completa de Clientes</h4>
                      <p>
                        Mantenha um histórico detalhado de compras e pagamentos de cada cliente, facilitando um
                        atendimento personalizado e eficiente.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="200">
                  <Card className="icon-box">
                    <Card.Body>
                      <i className="bx bx-cart"></i>
                      <h4>Controle Avançado de Vendas</h4>
                      <p>
                        Gerencie vendas de forma flexível, incluindo opções para vendas à vista, parceladas e
                        fiadas, com cálculos automáticos de pagamentos.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="300">
                  <Card className="icon-box">
                    <Card.Body>
                      <i className="bx bx-receipt"></i>
                      <h4>Envio de Comprovantes</h4>
                      <p>
                        Envie comprovantes de compra diretamente pelo WhatsApp do cliente, melhorando a
                        experiência de compra e facilitando o acompanhamento das transações.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} data-aos="fade-up" data-aos-delay="400">
                  <Card className="icon-box">
                    <Card.Body>
                      <i className="bx bx-bar-chart-alt"></i>
                      <h4>Relatórios Diários Personalizados</h4>
                      <p>
                        Acompanhe o desempenho do seu negócio com relatórios diários que mostram o balanço de
                        vendas, metas alcançadas e insights para tomada de decisões estratégicas.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl={5} className="d-flex align-items-stretch justify-content-center order-1 order-lg-2">
            <div data-aos="fade-left" data-aos-delay="100">
              <img src="/install-app/features.svg" className="img-fluid" alt="Recursos do App" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const DetailsSection = () => {
  useEffect(() => {
    // Inicialize o AOS para as animações, caso esteja usando isso
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  }, []);

  return (
    <section id="details" className="details">
      <Container>
        <Row className="content">
          <Col md={4} data-aos="fade-right">
            <img src="/install-app/details-1.png" className="img-fluid" alt="" />
          </Col>
          <Col md={8} className="pt-4" data-aos="fade-up">
            <h3>Transforme Relacionamentos em Resultados com a Gestão de Clientes!</h3>
            <p className="fst-italic">
              Ter informações detalhadas dos clientes é crucial para o seu negócio, pois permite um atendimento personalizado, aumenta a fidelização, facilita a identificação de padrões de compra e ajuda a planejar estratégias de marketing mais eficazes.
            </p>
            <ul>
              <li><i className="bi bi-check"></i> Histórico de compras</li>
              <li><i className="bi bi-check"></i> Histórico de pagamentos</li>
              <li><i className="bi bi-check"></i> Informações detalhadas</li>
            </ul>
            <p>
              Com dados precisos, você pode oferecer produtos e serviços que realmente atendam às necessidades dos clientes, melhorando a satisfação e impulsionando as vendas.
            </p>
          </Col>
        </Row>

        <Row className="content">
          <Col md={4} className="order-1 order-md-2" data-aos="fade-left">
            <img src="/install-app/details-2.png" className="img-fluid" alt="" />
          </Col>
          <Col md={8} className="pt-5 order-2 order-md-1" data-aos="fade-up">
            <h3>Gestão completa das vendas</h3>
            <p className="fst-italic">
              Ter uma gestão completa das vendas do seu negócio é essencial para garantir o sucesso e crescimento contínuo.
            </p>
            <p>
              Com dados precisos e detalhados sobre cada transação, você pode tomar decisões informadas, ajustar estratégias e identificar áreas de melhoria. Monitorar vendas à vista, parceladas e fiadas permite um controle rigoroso das finanças, enquanto o envio automático de comprovantes melhora a experiência do cliente.
            </p>
            <p>
              Além disso, acompanhar metas e gerar relatórios detalhados ajuda a prever demandas e otimizar o estoque. Em suma, uma gestão completa de vendas torna seu negócio mais eficiente, lucrativo e orientado ao cliente.
            </p>
          </Col>
        </Row>

        <Row className="content">
          <Col md={4} data-aos="fade-right">
            <img src="/install-app/details-3.png" className="img-fluid" alt="" />
          </Col>
          <Col md={8} className="pt-5" data-aos="fade-up">
            <h3>Gestão de vendas com controle de pagamentos parcelados, a vista e fiados</h3>
            <p>Um sistema de gestão de vendas eficiente traz diversos benefícios significativos para qualquer negócio. Ele não só simplifica o processo de vendas, como também melhora a experiência do cliente e aumenta a eficiência operacional. Os principais benefícios incluem:</p>
            <ul>
              <li><i className="bi bi-check"></i> Vendas a vista.</li>
              <li><i className="bi bi-check"></i> Vendas no parcelado.</li>
              <li><i className="bi bi-check"></i> Controle dos atrasados.</li>
              <li><i className="bi bi-check"></i> Baixa automática no estoque.</li>
              <li><i className="bi bi-check"></i> Comprovante para o cliente.</li>
            </ul>
            <p>
              Em resumo, um sistema de gestão de vendas bem implementado não só facilita o dia a dia operacional, mas também contribui diretamente para o crescimento e sucesso do negócio, promovendo uma relação mais próxima e lucrativa com os clientes.
            </p>
          </Col>
        </Row>

        <Row className="content">
          <Col md={4} className="order-1 order-md-2" data-aos="fade-left">
            <img src="/install-app/details-4.png" className="img-fluid" alt="" />
          </Col>
          <Col md={8} className="pt-5 order-2 order-md-1" data-aos="fade-up">
            <h3>Gestão de estoque automatizada</h3>
            <p className="fst-italic">
              O controle de estoque automatizado com baixa automática é uma solução eficiente para empresas que desejam otimizar a gestão de inventário.
            </p>
            <p>
              Neste sistema, a atualização do estoque é feita de forma automática no momento em que uma venda é registrada. Isso significa que não é necessário um processo manual separado para atualizar o estoque após cada transação, o que reduz significativamente o tempo gasto e minimiza erros humanos.
            </p>
            <ul className="d-none">
              <li><i className="bi bi-check"></i> Et praesentium laboriosam architecto nam .</li>
              <li><i className="bi bi-check"></i> Eius et voluptate. Enim earum tempore aliquid. Nobis et sunt consequatur. Aut repellat in numquam velit quo dignissimos et.</li>
              <li><i className="bi bi-check"></i> Facilis ut et voluptatem aperiam. Autem soluta ad fugiat.</li>
            </ul>
            <p>
              Com esse método, a empresa pode manter um registro preciso do nível de estoque em tempo real. Isso facilita o planejamento de compras, pois os gestores podem identificar rapidamente quando os produtos estão se esgotando e precisam ser reabastecidos.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const GallerySection = () => {
  useEffect(() => {
    // Inicializando o Swiper após a renderização
    new Swiper('.gallery-slider', {
      speed: 400,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  }, []);

  return (
    <section id="gallery" className="gallery">
      <Container data-aos="fade-up">
        <div className="section-title">
          <h2>Galeria</h2>
          <p>Aqui algumas das telas do aplicativo</p>
        </div>
      </Container>

      <Container fluid data-aos="fade-up">
        <div className="gallery-slider swiper">
          <div className="swiper-wrapper">
            {[
              'screenshot1.jpg',
              'screenshot2.jpg',
              'screenshot3.jpg',
              'screenshot4.jpg',
              'screenshot5.jpg',
              'screenshot6.jpg',
              'screenshot7.jpg',
              'screenshot8.jpg',
              'screenshot9.jpg',
              'screenshot10.jpg',
              'screenshot11.jpg'
            ].map((image, index) => (
              <div className="swiper-slide" key={index}>
                <a
                  className="gallery-lightbox"
                  data-gall="gallery-carousel"
                >
                  <img
                    src={`/images/${image}`}
                    className="img-fluid"
                    alt={`Screenshot ${index + 1}`}
                  />
                </a>
              </div>
            ))}
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </Container>
    </section>
  );
};

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Saul Goodman",
      role: "Ceo & Founder",
      image: "testimonials-1.jpg",
      quote:
        "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.",
    },
    {
      name: "Sara Wilsson",
      role: "Designer",
      image: "testimonials-2.jpg",
      quote:
        "Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.",
    },
    {
      name: "Jena Karlis",
      role: "Store Owner",
      image: "testimonials-3.jpg",
      quote:
        "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.",
    },
    {
      name: "Matt Brandon",
      role: "Freelancer",
      image: "testimonials-4.jpg",
      quote:
        "Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.",
    },
    {
      name: "John Larson",
      role: "Entrepreneur",
      image: "testimonials-5.jpg",
      quote:
        "Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.",
    },
  ];
  return (
    <section id="testimonials" className="testimonials section-bg d-none">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Testimonials</h2>
          <p>
            Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex
            aliquid fuga eum quidem.
          </p>
        </div>

        <div className="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100">
          <div className="swiper-wrapper">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="swiper-slide">
                <div className="testimonial-item">
                  <img
                    src={`install-app/testimonials/${testimonial.image}`}
                    className="testimonial-img"
                    alt={testimonial.name}
                  />
                  <h3>{testimonial.name}</h3>
                  <h4>{testimonial.role}</h4>
                  <p>
                    <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                    {testimonial.quote}
                    <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};

const PricingSection = () => {
  return (
    <section id="pricing" className="pricing d-none">
      <div className="container">
        <div className="section-title">
          <h2>Pricing</h2>
          <p>
            Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex
            aliquid fuga eum quidem.
          </p>
        </div>

        <div className="row no-gutters">
          {["Free", "Business", "Developer"].map((plan, index) => (
            <div key={index} className={`col-lg-4 box ${plan === "Business" ? "featured" : ""}`} data-aos={`fade-${index === 0 ? "right" : index === 1 ? "up" : "left"}`}>
              <h3>{plan}</h3>
              <h4>
                ${plan === "Free" ? "0" : plan === "Business" ? "29" : "49"}
                <span>per month</span>
              </h4>
              <ul>
                <li><i className="bx bx-check"></i> Quam adipiscing vitae proin</li>
                <li><i className="bx bx-check"></i> Nec feugiat nisl pretium</li>
                <li><i className="bx bx-check"></i> Nulla at volutpat diam uteera</li>
                <li className={plan === "Free" ? "na" : ""}><i className="bx bx-x"></i> <span>Pharetra massa massa ultricies</span></li>
                <li className={plan === "Free" ? "na" : ""}><i className="bx bx-x"></i> <span>Massa ultricies mi quis hendrerit</span></li>
              </ul>
              <a href="#" className="get-started-btn">Get Started</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const FaqSection = () => {
  return (
    <section id="faq" className="faq section-bg py-5">
      <Container data-aos="fade-up">
        <div className="text-center mb-4">
          <h2>Perguntas frequentes</h2>
          <p>As perguntas frequentes mais usadas</p>
        </div>

        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Como instalar no IOS?</Accordion.Header>
            <Accordion.Body>
              <p>O sistema IOS ainda está em fase de adaptação para essa nova tecnologia, mas é possível instalar no IOS sim.</p>
              <p><b>Adicione à tela inicial</b></p>
              <ol>
                <li>Toque no ícone de compartilhamento na parte inferior da tela (o ícone quadrado com uma seta para cima).</li>
                <li>Role para baixo na lista de opções e selecione "Adicionar à Tela Inicial".</li>
                <li>Você pode renomear o app se desejar.</li>
                <li>Toque em "Adicionar" no canto superior direito da tela para confirmar.</li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>Como tenho acesso?</Accordion.Header>
            <Accordion.Body>
              <p>Para ter acesso é necessário criar uma conta de usuário logo quando abre o app.</p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>Como adiciono meus contatos de clientes?</Accordion.Header>
            <Accordion.Body>
              <p>Para adicionar os contatos, pode adicionar direto pela tela inicial ou indo em <code>gestão &gt; contatos &gt; e tocar no botão de (+)</code> e preencher os dados do cliente.</p>
              <p>Na tela de cadastro pode preencher todos os campos necessários, e também pode importar da agenda de contatos do telefone.</p>
              <p>A lista de clientes só aparece os clientes que têm compras, mas pode pesquisar que aparece todos.</p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>Como crio meu estoque?</Accordion.Header>
            <Accordion.Body>
              <p>Na tela inicial tem um botão de adicionar estoque, e também em <code>gestão &gt; estoque &gt; e tocar no botão de (+)</code> que abre a tela de cadastro de produto.</p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>Como cadastro uma venda?</Accordion.Header>
            <Accordion.Body>
              <p>Para registrar uma venda, pode acessar direto na tela inicial ou em <code>gestão &gt; vendas &gt; e tocar no botão (+)</code> e abre a tela para escolher um cliente.</p>
              <p>Depois que escolher o cliente vai para a tela de escolher os produtos.</p>
              <p>Depois que escolher os produtos vai para a tela da forma de pagamento, escolhe a quantidade de parcelas e finaliza tocando em uma das opções de pagamento.</p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
    </section>
  );
};

const ContactSection = () => {
  return (
    <section id="contact" className="contact py-5">
      <Container data-aos="fade-up">
        <div className="text-center mb-4">
          <h2>Contato</h2>
          <p>Este app foi criado para me ajudar nas minhas vendas, decidi compartilhar com quem deseja usar também.</p>
        </div>

        <Row>
          <Col lg={6}>
            <Row>
              <Col lg={6} className="info">
                <BsMap size={30} />
                <h4>Endereço</h4>
                <p>Butantã,<br />São Paulo - SP</p>
              </Col>
              <Col lg={6} className="info">
                <BsEnvelope size={30} />
                <h4>Email</h4>
                <p>franciscosilva.executivo@gmail.com</p>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <p>Para entrar em contato direto comigo, pode mandar mensagem no Instagram: </p>
            <a href="https://www.instagram.com/franciscosilva_executivo?igsh=MWJiYXc3eG03ZHpudw==" className="instagram">
              <BsInstagram size={25} /> @franciscosilva_executivo
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};


export default InstalarApp;